import React from 'react';
import PropTypes from 'prop-types';

const RetypeEmail = ({value, onChange = () => {}, isError = false, isDisabled = false}) => (
    <div id="1row_retype_email" className="email__item">
        <div className="personal-info__lbl">Re-type email:*</div>
        <div className="personal-info__value">
            <input disabled={isDisabled}
                   className={`${isError ? `form-error` : ``}`}
                   value={value}
                   onChange={(event) => {onChange(event.target.value)}}
                   id="retype_email"
                   name="retype_email"
                   type="text"
                   placeholder="e.g. jonh.smith@gmail.com" />
            {isError &&
                <div className="validation_error err-popup" id="error_retype_email">
                    Emails do not coincide
                </div>
            }
        </div>
    </div>
)

RetypeEmail.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    isError: PropTypes.bool,
    isDisabled: PropTypes.bool,
};

export default RetypeEmail
